export default function(index, reels = 5){
    const row = ~~(index / reels);
    const reel = index % reels;
    return {reel, row};
}